import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
// import { ResidentModule } from './resident-details/resident.module';
// import { VillageStaffModule } from './village-staff/village-staff.module';
import { AuthenticationService } from './authentication/authentication.service';
import { CredentialsService } from './authentication/credentials.service';
// import { AuthenticationGuard } from './authentication/authentication.guard';
import { SignOutComponent } from './sign-out/sign-out.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AngularWebStorageModule } from 'angular-web-storage';
import { OfficerSearchDetailsModule } from './officer-search-details/officer-search-details.module';
// import { AdminModule } from './admin/admin.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResidentModule } from './resident-details/resident.module';
import { VillageStaffModule } from './village-staff/village-staff.module';
import { AdminModule } from './admin/admin.module';
import { AuthenticationGuard } from './authentication/authentication.guard';
import { ApiPrefixInterceptor } from './api-prefix.interceptor';
import { ChangePasswordComponent } from './forgot-password/change-password/change-password.component';
//import { CodeEnforcementComponent } from './code-enforcement/code-enforcement.component';
//import { AddressSearchComponent } from './code-enforcement/address-search/address-search.component';
import { CodeEnforcementModule } from './code-enforcement/code-enforcement.module';
import { HomeComponent } from './home/home.component';
import { BnNgIdleService } from 'bn-ng-idle';
import { CountdownModule } from "ngx-countdown";
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    SignOutComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    //CodeEnforcementComponent,
    // AddressSearchComponent,
    HomeComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    RouterModule,
    ResidentModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    VillageStaffModule,
    OfficerSearchDetailsModule,
    MatSnackBarModule,
    AngularWebStorageModule,
    AdminModule,
    CodeEnforcementModule,
    CountdownModule,
    MatDialogModule
  ],
  providers: [AuthenticationService, CredentialsService, AuthenticationGuard,BnNgIdleService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiPrefixInterceptor,
      multi: true,
    }],
  bootstrap: [AppComponent],
  exports: [

  ]
})
export class AppModule { }
